import { observable, computed, action, intercept, toJS } from 'mobx'; //{ set, toJS }
import { Match } from './models/Match';
import { comm } from '../comm';
import { integration } from '../integration';
import { sum } from 'lodash';
import { i18n } from '../i18n';
import { max } from 'lodash';
import {Hand} from './models/Hand';

class MainStore {
	gameVersion = process.env.CI === 'true' ? `b.${process.env.BITBUCKET_BUILD_NUMBER}` : '1773_skillz'; 

	constructor() {
		intercept(this, 'state', (change) => {
			var states = ['', 'lobby', 'waitForMatch', 'login', 'resume', 'tutorial', 'bet', 'tutorial-rules', 'play'];
			if (states.indexOf(change.newValue) < 0) {
				throw new Error(`${change.newValue}, is not a valid state. => ${states}`);
			}
			return change;
		});
		//setInterval(this.pollNotifications, 10000);
		window.usedImages = this.usedImages;
	}

	stakes = [];
	@observable balance = 0;
	@observable bet = 0;
	@observable prize = 0;
	@observable multiplier = 2;
	@observable coinAnimation = null;
	@observable coinAnimation2 = null;
	@computed get isMultipliedGame() { return this.multiplier !== 2}
	multiValues = [4, 6, 10]
	@observable showResultHandExplain = false;

	@observable skillzTimeTicking = false;
	@observable skillzTime = 0;
	@observable skillzHearts = 0;
	@observable skillzTourData = null;
	@observable skillzMatchTime = 150;	// seconds
	@observable showSummary = false;
	@observable showSkillzSettings = '';
	@observable showSkillzRules = 0;
	@observable showSkillzError = false;
	@observable showSkillzLegal = false;
	@observable showSkillzShopify = false;
	@observable showSkillzResume = false;
	@observable showSkillzComunity = false;
	@observable showSkillzExplainName = false;
	@observable showSkillzLeave = null;
	@observable showExternalPage = '';
	@observable skillzResponse = null;
	@observable showDiceSimulator = false;
	isSkillzInited = false;
	skillzBackButtons = [[null, '']];
	
	customValues = {
		handNames: ['casual', 'poker'],
		tables: ['blue'/* , 'green', 'red' */],
		cups: ['traditional'/* , 'vegas' */],
		dices: ['traditional'/* , 'vegas' */],
		usePopper: false
	}
	@observable custom = {
		handNames: this.customValues.handNames[1],
		table: this.customValues.tables[0],
		cup: this.customValues.cups[0],
		dice: this.customValues.dices[0],
		//usePopper: this.customValues.usePopper,
		usePopper: this.qs && this.qs.get('tap') ? this.qs.get('tap') === 'pop' : true,
		...JSON.parse(localStorage.getItem('custom'))
	};
	@action changeCustom(key, value = 'unset') {
		// update Phaser
		if(this.activeMatch !== null && this.custom[key] !== value) {
			window.manager.updateCustomSkin(key, value)
		}

		const temp = this.custom;
		this.custom = null;
		temp[key] = value !== 'unset' ? value : !temp[key];
		setPersistentStorage('custom', JSON.stringify(toJS(temp)));
		this.custom = temp;

		store.setCustomHudBanners();
	}

	@computed get hasCasualNames() {		return this.custom.handNames === 'casual';	}
	@action getHandName(goalName, force = '') {
		const textKey = goalName.replace(/-/g, '_');
		return force !== '' ? i18n.t(textKey + '_' + force)
			: (this.custom.handNames === 'poker' && i18n.exists(textKey+'_POKER')) ? i18n.t(textKey+'_POKER') 
			: i18n.t(textKey)
	}		
	@action setCustomHudBanners() {
		let top = this.custom.table === 'blue' ? 'blue' : 'gold';
		let bottom = this.custom.table;
		window.WrapperApp.postMessage('hud-banners?top='+top+'&bottom='+bottom+'&num=0');
	}

	@computed get deviceType () {	// possible values "Tablet" | "Mobile"
		const height = max([320, window.innerHeight]);
		const width = max([320, window.innerWidth]);
		const ratio = width / height;
		const type = ratio >= 0.6984 ? 'Tablet' : 'Mobile';
		//console.log(" GLEAM WINDOW: ", window.innerWidth, window.innerHeight, 'ratio', ratio, 'type =', type);
		return type
	}

	@observable animations = true;
	connectionType = 'unknown';
	deviceModel = 'web';

	@computed get is3HandGame() {
		//if (this.activeMatch) return this.activeMatch.roundCount === 3;
		return false;
	}
	@computed get is1HandGame() {
		//if (this.activeMatch) return this.activeMatch.roundCount === 1;
		return false;
	}
	@computed get is1or3HandGame() {
		return this.is1HandGame || this.is3HandGame;
	}

	fixUpLanguage = (lang) => {
		if(this.countryCode !== 'web') {
			if(lang === 'es' && this.countryCode !== 'ES')
				lang = 'mx';
		}
		return lang;
	}

	@computed get interstitialTestActive() {
		return (store.remoteConfig_interstitial_test === 'OPTIONA' || store.remoteConfig_interstitial_test === 'OPTIONB' || store.remoteConfig_interstitial_test === 'OPTIONC');
	}

	qs = new Map(decodeURI(window.location.search)
		.slice(1).split('&').map((p) => p.split(/=(.+)/)));
	// @computed get isHardRock() {
	// 	// return true;
	// 	return this.qs && this.qs.get('bundleId') === 'com.hardrock.diceparty';
	// }
	@computed get isProd () {
		return process.env.NODE_ENV === 'production';
	}
	@computed get isDev() {
		return process.env.NODE_ENV === 'development';
	}
	@computed get cfgFolder() {
		return (this.qs && this.qs.get('cfg')) || (this.isDev ? 'dev' : 'stage');
	}

	_onBackButton;
	get onBackButton() {
		return this._onBackButton;
	}
	set onBackButton(func) {
		console.log('SETTING ONBACK from =', this._onBackButton, 'to =', func);
		this._onBackButton = func || this.showExitModal;
	}

	@observable topBar = {
		to: '',
		//heartText: '',
		showHeart: false,
		showMenu: false,
		heightWide: '8.3dvh',
		heightTall: '14.5vw',
		wtRatio: '56/100',
	};

	usedImages = [];

	showExitModal = () => {
		store.modal = 'exitApp';
	};

	truncateValue(value, decim=1) {
		const prefix = [
			{ pow: 15, letter: 'Q' },
			{ pow: 12, letter: 'T' },
			{ pow: 9, letter: 'B' },
			{ pow: 6, letter: 'M' },
			{ pow: 3, letter: 'K' },
		];
		if (value.toString().length >= 4) {
			const find = prefix.find((v) => value >= Math.pow(10, v.pow));
			const resS = Math.floor(value / Math.pow(10, find.pow - decim)).toString();
			const resStr = resS.substring(0, resS.length - decim) + (decim > 0 ? ('.' + resS.substr(-decim)) : '') + find.letter;
			return resStr;
		} else {
			return value.toString();
		}
	}
	tresCommas(value) {
		return value.toLocaleString();
	}

	@computed get isInLobby () {
		const path = window.router.location.pathname;
		return path === '/'
	}
	@computed get isAnyPopupShown () {
		const arr = [
			this.modal !== '',
		]
		//console.log('7314 \t\t popups ::', arr.map(v => !!v ? '+' : '-').join(''));
		return arr.some(Boolean)
	}

	checkPopups = () => {
		if(!store.loginComplete || !store.user.loginConfirmed || this.isAnyPopupShown || this.showDisableScreen /* || this.activeMatch !== null */) 
			return

		if(this.activeMatch !== null)	return;

		if(!store.tutorialMode) {
			window.manager.showNotificationsPopup();
		} 
	};
	@computed get disablePageAnim() {
		return !!store.showDisableScreen
			|| store.modal !== ''
	}

	@observable purchaseComplete = false;
	@observable focus = true;
	//@observable preventReturnToSplash = false;
		
	@observable _settings = {
		sound: true,
		appNotif: true,
		language: 'en',
		theme: 'traditional',
		notifications: true,
		vibration: true,
		handStrengthMeter: false,
		...JSON.parse(localStorage.getItem('settings'))}; 
	@observable showBottomNav = false;

	@computed get settings() {
		return this._settings;
	}

	@computed get getLanguage() {
		// return 'de';
		return this._settings.language;
	}
	@computed get validLanguage() {
		return 'en'
		/* let lang = this._settings.language;
		switch (lang) {
			case 'br':
			case 'mx':
			case 'es':
			case 'de':
			case 'it':
				break;
			default:
				lang = 'en';
				break;
		}
		return lang; */
	}
	@computed get getTheme() {
		return this._settings.theme;
	}
	@action changeSetting(key, value = 'unset') {
		this._settings[key] = value !== 'unset' ? value : !this._settings[key];
		setPersistentStorage('settings', JSON.stringify(toJS(this._settings)));
	}

	@observable phaserInstanceIndex = 1;
	@observable debug = '';

	@observable aspectRatio = 0;
	@action recalcAspectRatio() {
		if (window.innerHeight > 300 && window.innerWidth > 300) {
			const height = max([320, window.innerHeight]);
			const width = max([320, window.innerWidth]);
			this.aspectRatio = width / height;
		}
	}
	aspectIs(name) {
		return this.aspectName === name;
	}
	@computed get aspectName() {
		//anything taller than an iPhone 6 1334/750
		if (this.aspectRatio < 0.5621) {
			return 'Tall'; //Like the iPhone X
		}
		//anything taller than an iPad Pro 11 inch
		if (this.aspectRatio < 0.6984) {
			return 'Standard'; // Like the iPhone 4 - 8
		}
		if (this.aspectRatio < 0.7) {
			return 'TabletPro'; // Like the iPad Pro 11 inch
		}
		//if (this.aspectRatio < 0.752) {
		if (this.aspectRatio < 0.85) {		// greater number for browser version
			return 'Tablet';
		}
		return 'Landscape';
	}

	@observable preloading = true;
	@observable phaserLoadPercentage = 0;
	@observable fakeLoadPercentage = 0;
	@observable reactLoadPercentage = 0;
	@computed get totalLoadPercentage() {
		var percentagesToCombine = [this.phaserLoadPercentage, this.reactLoadPercentage, this.fakeLoadPercentage];
		var total = sum(percentagesToCombine) / percentagesToCombine.length;
		return total;
	}
	@observable firstTimeRules = true;
	@observable loginComplete = false;

	@observable currentTosId = -1;
	@observable acceptedTosId = parseInt(localStorage.getItem('acceptedTosId'), 10);
	@computed get tosIsAccepted() {
		return true;
		/* return (
			this.currentTosId === parseInt(localStorage.getItem('acceptedTosId'), 10) ||
			this.currentTosId === this.acceptedTosId
		); */
	}

	@observable showDisableScreen = false;

	@observable showHeartsSpend = null;
	@computed get canUseExtraRoll() {
		return (
			this.activeMatch.canApplyFreeroll &&
			!this.activeMatch.currentHand.best &&
			!this.activeMatch.currentHand.complete
		);
	}
	@computed get isEligibleForRewardRoll() {
		return (
			this.activeMatch.canApplyFreeroll &&
			this.skillzHearts <= 0 &&
			!this.activeMatch.currentHand.best &&
			!this.activeMatch.currentHand.complete
		);
	}
	@computed get canUseHandReset() {
		return this.activeMatch.canApplyHandReset && this.skillzHearts >= this.resetHandCost;
	}
	@observable resetHandCost = 3;

	@computed get playOrSkip() {
		if(this.is3HandGame)
			return this.activeMatch.currentHand.best || !this.canUseExtraRoll;
		else 
			return this.activeMatch.currentHand.isWinningHand || !this.canUseExtraRoll;
	}

	@observable modal = '';

	enableAds = true;
	videoAdIsLoaded = false;
	wrapperCommandProcessing = false;
	wrapperVersion = 'web';
	firstLaunchUtcSecs = '0';
	hasPurchasedIAP = '';
	firstInterstitialDelay = 24 * 60;
	waitingToStartFTUE = false;

	remoteConfig_interstitial_test = 'default';
	wrapperDebugMsg = '';
	@observable pokerRush = false;
	botVideo = false;
	progressBarShownFirstTime = false;
	ftueMode = false;

	@computed get isFirstTimePractice() {
		return this.tutorialMode && !localStorage.getItem('play_tutorial_from_solo');
	}

	osVersion = 'web';
	deviceUid = 'web';
	countryCode = 'web';
	rawLang = 'n/a';
	@observable devicePlatform = localStorage.getItem('platform') || 'web'; // 'ios' | 'android'
	@computed get isIOS() {
		return this.devicePlatform === 'ios';
	}
	@computed get isAndroid() {
		return this.devicePlatform === 'android';
	}

	@observable state = 'login';
	@observable user = null;
	@observable activeMatch = null;
	@observable resuming = true;

	@observable tutorialMode = window.location.hash === '#tutorial';
	@observable tutorialState = '';

	@observable errorMessage = '';

	@observable phaserLoading = true;
	phaserSideLoading = false;
	phaserSideLoadImages = [];
	phaserSideLoadSpriteSheets = [];
	themeRecentlyReloaded = false;	// no theme reloading for skillz

	//Spinner
	@observable loadCount = 0;
	spinTimeout = null;
	@computed get spinner() {
		if (this.phaserLoading && this.state === 'play') {
			return true;
		}
		return this.loadCount > 0;
	}
	@action setSpinner = (on) => {
		if (on) {
			this.spinTimeout = setTimeout(() => (this.loadCount += 1), 500);
		} else {
			this.loadCount -= 1;
		}
	};
	@action forceRemoveSpinner = () => {
		clearTimeout(this.spinTimeout);
		this.loadCount = 0;
	};

	@observable isImmediateRematch = false;

	@action updateMatch = () => {
		return comm.GetMatch(this.activeMatch.matchId).then((data) => {
			this.activeMatch.updateFromNetwork(data.Payload.Match);
		});
	};

	@observable matchData = {};
	@action.bound createMatch(betId, _oppId, _rematchId) {
		if(store.bet > store.balance) {
			console.log(' LOW BALANCE!!!')
			store.errorMessage = 'low balance';
			return Promise.reject()
		} else 
		return comm.CreateMatch(betId).then(resp => {
			this.bet = resp.stakeAmount;
			this.prize = resp.prizeAmount;
			const hand = new Hand({
				bonusPointsIncluded: false,
				match: false,
				bestHandTarget: resp.goal.code,
				score: resp.prizeAmount,
				finalScore: resp.prizeAmount,
				
				rollsRemaining: 3, 	// TODO check when resume
			});
			this.matchData = {
				matchId: resp.startedAt,
				opponent: resp.opponent,
				goals: [resp.goal.name],
				roundCount: 1,
				hands: [hand],
				currentHand: hand
			};
			return this.matchData.matchId
		})
	}
	@action startMatchFromId(id, mode) {
		if (!mode) mode = 'play';
				
		// integration.onMatchStart();
		this.setActiveMatch(this.matchData, mode);
		return Promise.resolve()
	}
	@action setActiveMatch = (game, mode, fromResume = false) => {
		this.activeMatch = new Match(game, mode, false);
		this.activeMatch.fromResume = fromResume;
		this.state = 'play';

		// if (localStorage.getItem('gameInProgress') === this.activeMatch.matchId.toString()) {
		// 	store.modal = 'resume';
		// }
		if (!store.tutorialMode) {
			window.setPersistentStorage('gameInProgress', store.activeMatch.matchId);
		}
	};


	@action rollDice(held) {
		if (store.activeMatch.matchId !== 'intro2' && !store.tutorialMode)
			integration.postEvent('dice_roll', 'gameplay', store.activeMatch.handNumber);
		
		this.activeMatch.currentHand.rolled = false;
		return comm.ContinueRoll(held)
		.then((response) => {
			if (response.ErrorCode === 300019) {
				//let the game decide how to proceed since this is expected in the multiplayer game for now.
				return response;
			}
			if (response.ErrorCode === 300024 || response.ErrorCode === 300025) {
				console.warn('Game action failed.');
				return response;
			}
		
			var faces = response.deck.indexes;
			if (faces.length !== 9 || faces.find((f) => f > 5 || f < 0) !== undefined) {
				throw new Error(`Out of bounds! Faces length: ${faces.length} or face beyond 0 - 6 ${faces}`);
			}
			faces.forEach((f, i) => {
				this.activeMatch.currentHand.dice[i].showing = f;
			});
			this.activeMatch.currentHand.best = !!response.bestHand;
			this.activeMatch.currentHand.bonusPointsIncluded = false;
			this.activeMatch.currentHand.match = response.matchHand || [];
			this.activeMatch.currentHand.complete = response.remainingRolls === 0;
			this.activeMatch.currentHand.diceFaces = response.deck.faces;
			
			this.activeMatch.currentHand.nextRoll();
		})
		.catch((err) => {
			let txt = 'store.rollDice catch error:' + err;
			console.log(txt);
			// store.debug = txt + ' ' + store.debug;
		});
	}
	
	@action getGameState() {
		console.log('STORE ----- get game state')
		return comm.CheckOngoing().then(data => {
			console.log('ONGOING d =', data, 'am =', this.activeMatch)
			this.activeMatch.currentHand.Outcome = ["", "win", "lost", "tie"].indexOf(data.result);
			this.activeMatch.currentHand.handStrength = data.hand.cards.length === 0 ? -1 : data.result;
			this.activeMatch.currentHand.lastCombination = data.goal.code;
			this.activeMatch.currentHand.match = data.hand.cards.map((_v, i) => ({
				dice: data.hand.cardIndexes[i],
				face: data.hand.faceIndexes[i]
			}))
			console.log('\t\t my hand =', this.activeMatch.currentHand)

			this.activeMatch.opponent.hands = [{
				handStrength: !data.opponent.hand ? -1 : data.result,
				lastCombination: data.goal.code,
				match: data.opponent.hand?.cards.map((_v, i) => ({
					dice: data.opponent.hand?.cardIndexes[i],
					face: data.opponent.hand?.faceIndexes[i]
				}) || [])
			}]
		})
	}

	@action sendSeen() {
		return comm.SendSeen();
	}

	@action getMe() {
		return comm.GetMe().then(resp => {
			store.balance = resp.balance;
			store.multiplier = resp.multiplier.amount
			return resp
		});
	}
}

export const store = new MainStore();
